import { useMemo } from 'react';
import { useCastContext } from '../cast-context';
import {
  CastContext,
  CastMediaSession,
  CastMediaStatus,
  CastSender,
  CastSession,
  CastSessionStatus,
} from '../interfaces';
import { CastMessageManager } from '../utils/cast-message-manager';
import { useCastSession } from './use-cast-session';
import { useCastMedia } from './use-media-session';

export interface Cast {
  /**
   * CastSender object, from cast_sender google lib
   */
  sender?: CastSender;
  context?: CastContext;
  session?: CastSession;
  media?: CastMediaSession;
  message?: CastMessageManager;
  sessionStatus: CastSessionStatus;
  mediaStatus: CastMediaStatus;
}

export function useCast(): Cast {
  const { sender, context } = useCastContext();
  const { session, sessionStatus } = useCastSession();
  const { media, mediaStatus } = useCastMedia(session);

  const message = useMemo(() => {
    if (session && media) {
      return new CastMessageManager(session, media);
    }
  }, [session, media]);

  return {
    sender,
    context,
    session,
    media,
    message,
    sessionStatus,
    mediaStatus,
  } as const;
}
